import React, {useCallback, useEffect, useState} from 'react'
import {Container} from "reactstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBuilding, faCoins, faFileContract, faLaptopHouse, faMapMarkerAlt} from "@fortawesome/free-solid-svg-icons";
import {formatSalary} from "../../helpers/format";
import {FormattedMessage} from "react-intl";
import LocaleLink from "../Routes/LocaleLink";
import UserProfileCard from "../portfolio/UserProfileCard";
import {faHome} from "@fortawesome/pro-regular-svg-icons";
import * as PropTypes from "prop-types";

JobsDetailPageComponent.propTypes = {
    portfolioCta: PropTypes.bool,
}

JobsDetailPageComponent.defaultProps = {
    portfolioCta: true,
}

export default function JobsDetailPageComponent(props) {
    const [state, setState] = useState({})

    useEffect(() => {
        const {jobSlug} = props
        setState({
                formLink: jobSlug ? `/form-job/${jobSlug}` : null
            }
        )
    }, [])

    const renderSkills = useCallback(() => {
        const {skill_list} = props.offer;

        if (skill_list)
            return (
                <ul>
                    {skill_list.split(',').map((skill, key) => {
                        if (!skill || skill.trim() === '') return;
                        return (
                            <li className="btn-regular" key={key}>
                                {skill}
                            </li>
                        )
                    })}
                </ul>
            )
    }, []);

    const renderRemote = useCallback(() => {
        const {open_to_remote} = props.offer;

        switch (open_to_remote) {
            case "NONE":
                return (<p> <FontAwesomeIcon icon={faBuilding}/>
                    &nbsp; <FormattedMessage id="forms.remote.options.none" />
                </p>)
            case "PARTIAL":
                return (<p> <FontAwesomeIcon icon={faLaptopHouse}/>
                    &nbsp; <FormattedMessage id="forms.remote.options.partial" />
                </p>)
            case "FULL":
                return (<p><FontAwesomeIcon icon={faHome}/>
                    &nbsp; <FormattedMessage id="forms.remote.options.full" />
                </p>)
            default:
                return null
        }
    })

    return (
        <section className="sec-associat">
            <Container>
                <div className="associat-head">
                    <h1 className="line-heading">{props.offer.title}</h1>
                    <p>
                        {props.offer.hat}
                    </p>
                    <div className="post-wrap">
                        <ul className="post-list">
                            {
                                props.offer.address ?
                                    <li>
                                        <i>
                                            <FontAwesomeIcon icon={faMapMarkerAlt}/>&nbsp;
                                        </i>
                                        <span>{props.offer.address.city}</span>
                                    </li>
                                    : null
                            }
                            <li>
                                <i>
                                    <FontAwesomeIcon icon={faFileContract}/>&nbsp;
                                </i>
                                <span>{props.offer.type}</span>
                            </li>
                            <li>
                                <i>
                                    <FontAwesomeIcon icon={faBuilding}/>&nbsp;
                                </i>
                                <span>{props.offer.business_unit}</span>
                            </li>
                            <li>
                                <i>
                                    <FontAwesomeIcon icon={faCoins}/>&nbsp;
                                </i>
                                <span>
                                                {formatSalary(props.offer.salary_low, true, false)}
                                    {' '}
                                    <FormattedMessage id={"wording.to"} defaultMessage={"à"}/>
                                    {' '}
                                    {formatSalary(props.offer.salary)}
                                            </span>
                            </li>
                            { props.portfolioCta && (
                                <li className="pull-right">
                                    <LocaleLink to={{ pathname: "/cooptation", state:  props.offer }} className="cooptation-link">
                                        <FormattedMessage
                                            id="portfolio.job_detail.sponsorship"
                                            defaultMessage="JE PARRAINE UN AMI"
                                        />
                                    </LocaleLink>
                                </li>
                            )}
                        </ul>
                        { props.portfolioCta && (
                            <div className="post-action">
                                <LocaleLink to={{ pathname: "/cooptation", state:  props.offer }} className="cooptation-link cooptation-link-mobile">
                                    <FormattedMessage
                                        id="portfolio.job_detail.sponsorship"
                                        defaultMessage="JE PARRAINE UN AMI"
                                    />
                                </LocaleLink>
                                <LocaleLink to={state.formLink} className="btn btn-danger">
                                    <FormattedMessage
                                        id="portfolio.job_detail.button"
                                        defaultMessage="JE POSTULE"
                                    />
                                </LocaleLink>
                            </div>
                        )}
                    </div>
                </div>
                <div className="detail-associat">
                    <div className="topics-associat">
                        <div className="topic-text">
                            <h2>
                                <FormattedMessage
                                    id="portfolio.job_detail.company"
                                    defaultMessage="LA SOCIÉTÉ"
                                />
                            </h2>
                            <div className="topic-list"
                                 dangerouslySetInnerHTML={{
                                     __html: props.offer.company_description
                                 }}>
                            </div>
                        </div>
                        <div className="topic-text">
                            <h2>
                                <FormattedMessage
                                    id="portfolio.job_detail.description"
                                    defaultMessage="DESCRIPTION DU POSTE"
                                />
                            </h2>
                            <div className="topic-list"
                                 dangerouslySetInnerHTML={{
                                     __html: props.offer.description
                                 }}>
                            </div>
                            <h3>
                                <FormattedMessage
                                    id="portfolio.job_detail.package"
                                    defaultMessage="Package"
                                />
                            </h3>
                            <div className="topic-list"
                                 dangerouslySetInnerHTML={{
                                     __html: props.offer.benefits
                                 }}>
                            </div>
                        </div>
                        <div className="topic-text">
                            <h2>
                                <FormattedMessage
                                    id="portfolio.job_detail.profile"
                                    defaultMessage="PROFIL RECHERCHé"
                                />
                            </h2>
                            <div className="topic-list"
                                 dangerouslySetInnerHTML={{
                                     __html: props.offer.profile_looked_for
                                 }}>
                            </div>
                        </div>
                    </div>
                    <div className="reference-associat">
                        <div className="technology">
                            <h2>
                                <FormattedMessage
                                    id="portfolio.job_detail.skills"
                                    defaultMessage="COMPéTENCES REQUISES"
                                />
                            </h2>
                            {renderSkills()}
                        </div>
                        <div className="topic-text">
                            <h2>
                                <FormattedMessage
                                    id="portfolio.job_detail.open_to_remote"
                                    defaultMessage="Télétravail"
                                />
                            </h2>
                            <div className="topic-list">
                                {renderRemote()}
                            </div>
                        </div>
                        <div className="card-regular">
                            <div>
                                <h2>
                                    <FormattedMessage
                                        id="portfolio.job_detail.title.more"
                                        defaultMessage="LES PLUS DU POSTE"
                                    />
                                </h2>
                                <div className="topic-list"
                                     dangerouslySetInnerHTML={{
                                         __html: props.offer.bonus_package
                                     }}>
                                </div>
                            </div>
                        </div>
                        { props.portfolioCta && (
                            <div className="btn-wrap">
                                <LocaleLink to={state.formLink} className="btn btn-danger">
                                    <FormattedMessage
                                        id="portfolio.job_detail.button"
                                        defaultMessage="JE POSTULE"
                                    />
                                </LocaleLink>
                            </div>
                        )}

                        <UserProfileCard user={props.offer.owner}/>

                    </div>
                </div>
                { props.portfolioCta && (
                    <div className="btn-wrap">
                        <LocaleLink to={state.formLink} className="btn btn-danger">
                            <FormattedMessage
                                id="portfolio.job_detail.button"
                                defaultMessage="JE POSTULE"
                            />
                        </LocaleLink>
                    </div>
                )}
            </Container>
        </section>
    )
}
